import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';
import { forwardRef } from 'react';
import { FilterButtonV2 } from '../FilterButtonV2';

import styles from './AdvancedFiltersButton.css';

interface IAdvancedFiltersButtonProps {
  onClick: VoidFunction;
  showBadge?: boolean;
  children: string;
}

export const AdvancedFiltersButtonV2 = forwardRef<HTMLDivElement, IAdvancedFiltersButtonProps>(
  function AdvancedFiltersButton({ onClick, showBadge, children }, ref) {
    return (
      <div data-name="AdvancedFiltersContainer" className={styles['button']} ref={ref}>
        <FilterButtonV2 beforeIcon={<IconActionFilters16 color="primary_100" />} onClick={onClick} flexible>
          {children}
        </FilterButtonV2>
        {showBadge ? <div className={styles['badge']} /> : null}
      </div>
    );
  },
);
